import { render, staticRenderFns } from "./activitiesDetail.vue?vue&type=template&id=772858e6&scoped=true&"
import script from "./activitiesDetail.vue?vue&type=script&lang=js&"
export * from "./activitiesDetail.vue?vue&type=script&lang=js&"
import style0 from "./activitiesDetail.vue?vue&type=style&index=0&id=772858e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772858e6",
  null
  
)

export default component.exports